// extracted by mini-css-extract-plugin
module.exports = {"redirectModal":"_16e170a","continueButton":"_c2913f4","flagWrapper":"_1960710","location":"_6b1efb7","access":"_bc2d885","pokerstarsIcon":"_ea11b3c","transparent":"_2b29d7c"};